<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="mappedPccLocations"
			:loading="loading"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			fixed-header
			dense
			:search="appBarSearch"
			:height="pageHeight(176)"
			:items-per-page="-1"
			group-by="medicalInstitution.institutionName"
			:group-expanded="[]">
			<!-- <template #item="{ item }"> -->
			<template #item="{ item }">
				<!-- @click.stop="openViewDialog(item)" -->
				<tr class="text-left" @click="selectedLocationRow(item)">
					<td>
						{{ item.hospital.hospitalName }}
					</td>
					<td class="text-right">
						<v-menu left bottom class="py-0" offset-y transition="slide-x-transition">
							<template #activator="{ on, attrs }">
								<v-btn icon color="main_black" v-bind="attrs" v-on="on">
									<v-icon>mdi-dots-horizontal</v-icon>
								</v-btn>
							</template>
							<v-list class="px-0" dense>
								<v-list-item class="py-0 my-0" link dense @click="selectedLocationRow(item)">
									<v-list-item-icon class="mx-1">
										<v-icon class="icon-img mdi-18px" color="black">mdi-eye</v-icon>
									</v-list-item-icon>
									<v-list-item-content class="font-bold font-size14">
										{{ $t('view') }}
									</v-list-item-content>
								</v-list-item>
								<v-divider />
								<v-list-item class="py-0 my-0" link dense @click="editLocation(item)">
									<v-list-item-icon class="mx-1">
										<v-icon class="icon-img mdi-18px" color="black">mdi-pencil</v-icon>
									</v-list-item-icon>
									<v-list-item-content class="font-bold font-size14">
										{{ $t('edit') }}
									</v-list-item-content>
								</v-list-item>
								<v-divider />
								<v-list-item link dense @click.stop="unMapLocation(item)">
									<v-list-item-icon class="mx-1">
										<v-icon color="main_red">mdi-trash-can-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content class="font-bold font-size14">
										{{ $t('delete') }}
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-menu>
					</td>
				</tr>
			</template>

			<!-- Group Header Template -->
			<template #[`group.header`]="{ group, headers, toggle, isOpen, items }">
				<td @click="toggle" class="text-left expand-data-table-office" :colspan="10">
					<v-row class="align-center d-flex pl-2">
						<v-col class="py-0 pl-0" cols="4">
							<v-btn small icon :ref="group" :data-open="isOpen">
								<v-icon small v-if="isOpen" color="primary">mdi-arrow-down-drop-circle</v-icon>
								<v-icon small v-else color="primary">mdi-arrow-right-drop-circle</v-icon>
							</v-btn>
							<span class="font-weight-bold ml-1 mr-1">{{ group }}</span>
						</v-col>
						<v-col cols="7" class="py-0 my-0">
							<v-chip pill x-small color="primary" class="mx-2 text--black custom-chip-size" label>
								{{ items.length }} {{ items.length > 1 ? $t('hospitals') : $t('hospital') }}
							</v-chip>
						</v-col>
					</v-row>
				</td>
			</template>
		</v-data-table>

		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				unMapLocation();
			" />
	</div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { getRowsForDataTable, showErrorAlert } from '../../../utils/utilities';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	name: 'PCCLocationMapping',
	components: { DeleteDialog },
	data () {
		return {
			loading: true,
			showViewDialog: false,
			selectedItem: null,
			mappedPccLocations: [],
			showDeleteDialog: false,
		};
	},
	computed: {
		...mapGetters({ appBarSearch: 'filterbar/getSearch', pageHeight: 'pageHeight' }),
		...mapState({
			pccFacilities: (state) => state.pcc.pccFacilities,
			viewDetailsDrawer: (state) => state.viewDetailsDrawer,
			pccMappedLocations: (state) => state.pccMappedLocations,
			detailsDrawer: (state) => state.detailsDrawer,
		}),
		headers () {
			return [
				{ text: this.$t('location-name'), value: 'hospital.hospitalName' },
				{ text: '', value: 'actions', align: 'end' },
			];
		},
	},
	async mounted () {
		this.loadMappedLocations();
	},
	methods: {
		getRowsForDataTable,
		...mapActions({
			getMappedPccLocations: 'pcc/getMappedPccLocations',
			pccLocationDeleteMapping: 'pcc/pccLocationDeleteMapping',
		}),
		async loadMappedLocations () {
			this.loading = true;
			this.mappedPccLocations = (await this.getMappedPccLocations()).data;
			this.loading = false;
		},
		synchronizeAddDrawers (item) {
			this.$store.commit('SET_DETAILS_DRAWER', {
				detailsDrawer: true,
				page: 'PointClickCare Location Mapping',
				item: item,
			});
		},
		async selectedLocationRow (item) {
			await this.$store.commit('mapping/SET_SELECTED_PCC_LOCATIONS', item);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', true);
		},
		editLocation (item) {
			this.$store.commit('mapping/SET_SELECTED_PCC_LOCATIONS', item);
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: '/pccLocationMapping',
			});
		},
		deleteMapping (item) {
			this.selectedItem = item;
			this.showDeleteDialog = true;
		},
		async unMapLocation (item = this.selectedItem) {
			const unMapLocationResponse = await this.pccLocationDeleteMapping(item.id);
			if (unMapLocationResponse.resFlag) {
				this.loadMappedLocations();
			} else {
				showErrorAlert(unMapLocationResponse.msg);
			}
		},
	},
	watch: {
		viewDetailsDrawer (val) {
			if (!val) {
				this.loadMappedLocations();
			}
		},
		detailsDrawer (val) {
			this.loadMappedLocations();
		},
	},
};
</script>
